import React, { useEffect, useState } from 'react';
import Countdown from '@/presentation/reusables/Countdown';
import Dialog from '@/presentation/reusables/Dialog';
import VerificationCode from '@/presentation/reusables/VerificationCode';
import { WrapperConfirmDialog } from './styled';

import type { TActionState } from '../../types';

interface IProps {
  actionState: TActionState;
  controllerActionState: (state: Partial<TActionState>) => void;
  onValidatingCode: (validationCode: number) => void;
}

const ValidationDialog = ({
  actionState,
  controllerActionState,
  onValidatingCode
}: IProps) => {
  const [countdownActive, setCountdownActive] = useState(false);
  const [countdownSeconds, setCountdownSeconds] = useState(0);
  const [isActive, setIsActive] = useState(false);

  const types: any = {
    EMAIL: {
      title: 'Ingresa el código que te enviamos al correo'
    },
    PHONE: {
      title: 'Ingresa el código que te enviamos al'
    },
    DEFAULT: {
      title: ''
    }
  };

  useEffect(() => {
    const { action } = actionState;
    setIsActive(action === 'VALIDATION');
  }, [actionState]);

  useEffect(() => {
    if (isActive) {
      setCountdownActive(true);
      setCountdownSeconds(180);
    } else {
      setCountdownActive(false);
      setCountdownSeconds(0);
    }
  }, [isActive]);

  useEffect(() => {
    if (isActive && !countdownActive && countdownSeconds === 0) {
      controllerActionState({ status: 'FINISH' });
    }
  }, [countdownActive, countdownSeconds]);

  const handlerCancel = () => {
    controllerActionState({
      action: 'DEFAULT',
      code: '',
      status: 'DEFAULT'
    });
  };

  const setValue = (v: string) => {
    if (v.length === 4) {
      onValidatingCode(parseInt(v, 10));
    } else {
      controllerActionState({ status: 'DEFAULT' });
    }
  };

  return (
    <Dialog
      handlerClose={handlerCancel}
      maxWidth="360px"
      show={isActive}
      zIndex={1000}
    >
      <WrapperConfirmDialog>
        <div>
          <p>
            <span>{types[actionState.input]?.title} </span>
            <span>{actionState?.newValue}</span>
            {actionState?.input === 'PHONE' && <span> por SMS.</span>}
          </p>
          <p>Ingresa tu código de verificación</p>
        </div>
        <VerificationCode setValue={setValue} status={actionState?.status} />
        <p>
          Si no te llegó el código, solicita uno nuevo en:{' '}
          <Countdown
            isActive={countdownActive}
            seconds={countdownSeconds}
            setIsActive={setCountdownActive}
            setSeconds={setCountdownSeconds}
          />
        </p>
      </WrapperConfirmDialog>
    </Dialog>
  );
};

export default ValidationDialog;
